import { preloadExternalShare } from '@confluence/external-share/entry-points/preloadExternalShare.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const preloadExternalShareRoute = (match: RouteMatch): Promise<void | Error[] | unknown[]> =>
	waitForAllReturnWhenError([
		preloadExternalShare({
			shareToken: match.params.externalToken,
			contentId: match.params.contentId === 'undefined' ? undefined : match.params.contentId,
		}),
	]);
